import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { CARD_BORDER_RADIUS, colors, MUNI_DETAIL_INPUT_HEIGHT, MUNI_INDICATOR_WIDTH } from './constants.js';

function MuniIndicatorBadge({ icon, label, active, tooltip, loading = false }) {
  return (
    <Tooltip title={loading ? 'Loading...' : (tooltip || label)} placement="top">
      <Box
        component="span"
        sx={{
          display: 'flex',
          width: MUNI_INDICATOR_WIDTH,
          height: MUNI_DETAIL_INPUT_HEIGHT,
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            p: '5px 6px',
            border: '1.5px solid',
            borderColor: loading ? colors.borderTertiary : (active ? colors.activeSuccess : colors.borderTertiary),
            borderRadius: CARD_BORDER_RADIUS,
            bgcolor: loading ? colors.bgPrimary : (active ? colors.activeSuccessBg : colors.bgPrimary),
            flexShrink: 0,
            boxSizing: 'border-box',
            overflow: 'hidden',
          }}
        >
        {loading ? (
          <CircularProgress size={16} />
        ) : (
          <>
        <Box sx={{ fontSize: 17, color: active ? colors.activeSuccess : colors.textSecondary, mb: 0.25, lineHeight: 1 }}>
          {icon}
        </Box>
        <Typography
          sx={{
            fontSize: 9,
            fontWeight: 500,
            textAlign: 'center',
            lineHeight: 1.15,
            color: active ? colors.textPrimary : colors.textSecondary,
            m: 0,
          }}
        >
          {label}
        </Typography>
          </>
        )}
      </Box>
      </Box>
    </Tooltip>
  );
}

export default React.memo(MuniIndicatorBadge);
